<template lang="pug">
    draggable(v-model="model")
        meditationItem(v-for="item in model" :key="item.id" :item="item")
</template>

<script>
    import draggable from 'vuedraggable';
    import { mapFields } from 'vuex-map-fields';
    import MeditationItem from './meditationItem';

    export default {
        components: {
            draggable,
            MeditationItem
        },
        computed: {
            ...mapFields('businesses', {
                model: 'business.definitions.sessions'
            })
        }
    };
</script>
